import { Question, QuestionTypes } from '@playbooks/core/src/interfaces/ActionCard'

import { useTranslation } from '../contexts/localization/Localization'
import { parseDate } from './utils'

/**
 * Get the answer provided by the user to the given Action Card question.
 * @param question Question to find the answer to
 * @param translation Translator function
 * @returns Answer as string
 */
export default function getAnswer(
  question: Question,
  translation: ReturnType<typeof useTranslation>['text'],
  useBrackets: boolean,
) {
  const text = useBrackets ? `(${question.text})` : `${question.text}`

  switch (question.type) {
    case QuestionTypes.DROPDOWN: {
      const answer = (question.data as { id: number; name: string }[]).find(item => item.id === question.value)
      return dangerousTagsHandler(answer?.name || text, question.text)
    }

    case QuestionTypes.CHECKBOX: {
      return dangerousTagsHandler(question?.value ? translation('yes') : translation('no'), question?.text)
    }

    case QuestionTypes.LONG_TEXT: {
      return dangerousTagsHandler((question?.value as string)?.replaceAll('\n', '<br />') || text, question?.text)
    }

    case QuestionTypes.DATE: {
      return dangerousTagsHandler(parseDate(question?.value as string)?.toLocaleDateString() ?? text, question?.text)
    }

    case QuestionTypes.DATE_TIME: {
      return dangerousTagsHandler(parseDate(question?.value as string)?.toLocaleString() ?? text, question?.text)
    }

    default:
      return dangerousTagsHandler(question?.value?.toString?.() || text || question?.type, question?.text)
  }
}

function dangerousTagsHandler(value: string, fieldName: string): string {
  const tags = [
    '<applet',
    '<style',
    '<link',
    '<iframe',
    '<script',
    '<img',
    '<video',
    '<comment',
    '<embed',
    '<link',
    '<listing',
    '<meta',
    '<noscript',
    '<object',
    '<plaintext',
    '<script',
    '<xmp',
    'onmouseover=',
    'onerror=',
  ]

  for (const tag of tags) {
    if (value.includes(tag))
      return `<p style="color: red !important">The "${fieldName}" field has dangerous tags or attributes. Check it out.</p>`
  }

  return value
}
